// Formation-document lock for formed locations, shared by the layout and the
// Business page. The server stores formation_docs_due_at; until then the filing
// screens stay open with a countdown, afterwards they close until the formation
// paper, EIN letter and owner ID photo are stored. Personal is never locked.
export const FORMED_STRUCTURES = ['LLC', 'Corporation', 'S-Corp', 'C-Corp', 'Partnership', 'Non-Profit', 'LLP'];

const DAY_MS = 24 * 60 * 60 * 1000;

export function formationLockState(location, now = Date.now(), storedCount) {
  const formed = !!location && FORMED_STRUCTURES.includes(location.legal_structure);
  const count = storedCount ?? Number(location?.formation_document_count || 0);
  const docsReady = count >= 3;
  if (!formed || docsReady) {
    return { formed, docsReady, inGrace: false, daysLeft: 0, locked: false };
  }
  const due = location.formation_docs_due_at ? new Date(location.formation_docs_due_at).getTime() : NaN;
  const inGrace = Number.isFinite(due) && due > now;
  const daysLeft = inGrace ? Math.max(1, Math.ceil((due - now) / DAY_MS)) : 0;
  return { formed, docsReady, inGrace, daysLeft, locked: !inGrace };
}

export function graceMessage(daysLeft) {
  return `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left to upload the formation paper, EIN letter, and owner ID photo. After that, these screens close until they are stored.`;
}

// Divisions (state registrations) for the Transactions and Budgets pickers.
// While a formed location's filing screens are closed the server refuses the
// list (403, FORMATION_DOCS_REQUIRED), so the request is not made and the
// picker is simply empty, instead of logging an error on every page load.
export async function loadDivisionsFor(location, fetchList, now = Date.now()) {
  if (!location || formationLockState(location, now).locked) return [];
  try {
    const response = await fetchList(location.id);
    return Array.isArray(response?.data) ? response.data : [];
  } catch (error) {
    if (error?.response?.status === 403) return [];
    throw error;
  }
}
